import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  getStoredToken,
  extractAndSaveToken,
  markBotLoginSource,
} from "../../../utils/apiService";

const AuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  // Check URL for token param first (bot link flow)
  const urlParams = new URLSearchParams(location.search);
  const urlToken = urlParams.get("token");

  if (urlToken) {
    extractAndSaveToken();
    markBotLoginSource();
  }

  const token = getStoredToken();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;
